import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import { formatNumber } from "../../../utils/DefaultFunction";
// Highcharts renders to SVG/canvas, so it needs a real colour — CSS variables
// are not resolved inside chart option objects.
import { PRIMARY_BG } from "../../../theme/brand";

const MessageDistributionChart = ({ data ,avg}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const hours = data.map((d) => d.hour);
    const counts = data.map((d) => d.count);

    const totalMessages = counts.reduce((sum, val) => sum + val, 0);

    // const dailyAverage = totalMessages / data.length;
    const dailyAverage = avg;

    Highcharts.chart(chartRef.current, {
      chart: {
        type: "column",
        backgroundColor: "white",
        spacing: [10, 10, 15, 10]
      },
      title: { text: null },
      credits: { enabled: false },
      xAxis: {
        categories: hours,
        gridLineWidth: 0,
        lineWidth: 0,
        labels: {
          rotation: 0
        }
      },
      yAxis: {
        title: { text: null },
        gridLineDashStyle: "Dot",
        gridLineColor: "#6b7280"
      },
      legend: { enabled: false },
      tooltip: {
        useHTML: true,
        formatter: function () {
          return `
            <div style="margin:6px 0;">
              ${this.x}<br/>
              <span style="color:${PRIMARY_BG};">Total Messages: ${formatNumber(this.y)}</span><br/>
              <span style="color:#f59e0b;">Daily Avg: ${dailyAverage.toFixed(2)}</span>
            </div>`;
        }
      },
      
      plotOptions: {
        column: {
          borderRadius: 2, 
          pointPadding: 0.1,
          borderWidth: 0
        }
      },
      series: [
        {
          name: "Messages",
          type: "column",
          data: counts,
          color: PRIMARY_BG
        },
        {
          name: "Daily Average",
          type: "line",
          data: Array(data.length).fill(dailyAverage),
          color: "#f59e0b", 
          lineWidth: 2,
          marker: { enabled: false },
          gridLineDashStyle: "Dot",
          enableMouseTracking: false 
        }
      ]
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div>
      <div ref={chartRef} />
    </div>
  );
};

export default MessageDistributionChart;
